import NoAccessIcon from '../../../../public/assets/No_access.svg';

interface NoAccessScreenProps {
  message: string;
}

const NoAccessScreen = ({ message }: NoAccessScreenProps) => (
  <div className="flex flex-col items-center justify-center gap-5 px-4 w-full h-full">
    <NoAccessIcon className="flex max-w-[300px] max-h-[200px]" />
    <div className="flex flex-col gap-1 max-w-[280px] sm:max-w-xs">
      <p className="text-bodyMedium font-medium text-[#474A4C] text-center">
        {message}
      </p>
      <p className="text-body-medium text-[#474A4C] text-center leading-4">
        Please contact your administrator for access.
      </p>
    </div>
  </div>
);

export default NoAccessScreen;
